var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("CrearMovilidad"),
      _vm._v(" "),
      _c("Reporte"),
      _vm._v(" "),
      _c("VerInformacionInterinato"),
      _vm._v(" "),
      _c("aprobar-tipo-movilidad"),
      _vm._v(" "),
      _c("suspencion-tipo-movilidad"),
      _vm._v(" "),
      _c("suspencion-interinato-movilidad"),
      _vm._v(" "),
      _c("anular-tipo-movilidad"),
      _vm._v(" "),
      _vm.funcionario === null
        ? _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { attrs: { align: "center" } },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      size: 70,
                      width: 7,
                      color: "purple",
                      indeterminate: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.funcionario !== null
        ? _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "grey lighten-2 text--info" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "px-3" },
                        [
                          _vm.$util.permisoRol([84])
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    color: "primary",
                                    to: "/persona/movilidad"
                                  }
                                },
                                [_c("v-icon", [_vm._v("arrow_back")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v("\n            Movilidad\n          ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _vm.urlFoto === ""
                                ? _c("v-icon", { attrs: { size: "10rem" } }, [
                                    _vm._v("person")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.urlFoto !== ""
                                ? _c("v-img", {
                                    staticClass: "grey lighten-2",
                                    attrs: {
                                      src: _vm.urlFoto,
                                      "lazy-src": _vm.urlFoto,
                                      heigth: "10rem",
                                      width: "10rem"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "placeholder",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "fill-height": "",
                                                    "align-center": "",
                                                    "justify-center": "",
                                                    "ma-0": ""
                                                  }
                                                },
                                                [
                                                  _c("v-progress-circular", {
                                                    attrs: {
                                                      indeterminate: "",
                                                      color: "grey lighten-5"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      1258913907
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md9: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { md6: "" } }, [
                                    _c("strong", [_vm._v("Nombre completo:")]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.funcionario.nombre) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md6: "" } }, [
                                    _c("strong", [
                                      _vm._v("Número de documento: ")
                                    ]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.funcionario.nro_doc) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md6: "" } }, [
                                    _c("strong", [
                                      _vm._v("Fecha de incorporación: ")
                                    ]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.fecha_ingreso != null
                                            ? _vm
                                                .$moment(
                                                  _vm.fecha_ingreso,
                                                  "YYYY-MM-DD"
                                                )
                                                .format("DD/MM/YYYY")
                                            : "Sin fecha de incorporación"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { md6: "" } }, [
                                    _c("strong", [_vm._v("Ítem: ")]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.funcionario.item) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "" } },
                                    [
                                      _c("strong", [
                                        _vm._v("Estado servidor público: ")
                                      ]),
                                      _vm._v(" "),
                                      _vm.esActiva
                                        ? _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: "rgba(100, 250, 50, 0.5)"
                                              }
                                            },
                                            [_vm._v("Activo")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.esActiva
                                        ? _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: "rgba(240, 50, 50, 0.5)"
                                              }
                                            },
                                            [_vm._v("Inactivo")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "grey lighten-2 text--info" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-flex", { staticClass: "px-3" }, [
                        _c("strong", [
                          _vm._v(
                            "\n            Movimientos registrados\n          "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          !_vm.filterShow
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-refresh",
                                  attrs: { slot: "activator", icon: "" },
                                  on: {
                                    click: function(v) {
                                      _vm.filterShow = true
                                    }
                                  },
                                  slot: "activator"
                                },
                                [_c("v-icon", [_vm._v("filter_list")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Filtros")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _vm.filterShow
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-refresh",
                                  attrs: { slot: "activator", icon: "" },
                                  on: {
                                    click: function(v) {
                                      _vm.filterShow = false
                                    }
                                  },
                                  slot: "activator"
                                },
                                [_c("v-icon", [_vm._v("filter_list")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ocultar")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.obtenerDatos()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("refresh")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.updateList")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.filterShow
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  type: "number",
                                  label: "Item",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterItem }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Fecha desde",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterFechaDesde }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Fecha conclusión",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterFechaHasta }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Fecha de registro",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterFechaRegistro }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Tipo de movimiento",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterTipoMovimiento }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Unidad",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterUnidad }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Cargo",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterCargo }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Puesto",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterPuesto }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Nro de memorándum",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterNroMemorandum }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Estado",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterEstado }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.vMovimientosMovilidads,
                              "item-key": "id",
                              search: _vm.filters,
                              "custom-filter": _vm.customFilter,
                              "no-data-text": "Sin datos",
                              "rows-per-page-items": [
                                10,
                                25,
                                { text: "Todos", value: -1 }
                              ]
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(items) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(items.item.nro_item) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(items.item.fecha_desde) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(items.item.fecha_hasta) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                items.item.fecha_registro
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                items.item.tipo_movimiento
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(items.item.unidad) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(items.item.cargo) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(items.item.puesto) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                items.item.nro_memorandum
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          items.item.estado === "Programado"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Aprobado\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Concluido"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Aprobado\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Aprobado"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(items.item.estado) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Alta Temporal"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [_vm._v("Aprobado")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Suspendido"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [_vm._v("Aprobado")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Baja"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [_vm._v("Aprobado")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Baja Temporal"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [_vm._v("Aprobado")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Rechazado"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "brown",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(items.item.estado)
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.estado === "Pendiente"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "orange",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(items.item.estado)
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            items.item.id_estado == 1 ||
                                            items.item.id_estado == 53
                                              ? "colorActivo"
                                              : "text-xs-center"
                                        },
                                        [
                                          items.item.id_tipo_justificacion == 11
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color:
                                                      "rgba(177, 17, 167,0.6)",
                                                    icon: "",
                                                    title: "Ver informacion"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.verInformacionInterinato(
                                                        items.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("visibility")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !items.item.cargoEspecial &&
                                          (items.item.id_tipo_justificacion ==
                                            7 ||
                                            items.item.id_tipo_justificacion ==
                                              2 ||
                                            items.item.id_tipo_justificacion ==
                                              1 ||
                                            items.item.id_tipo_justificacion ==
                                              11) &&
                                          (items.item.id_estado == 1 ||
                                            items.item.id_estado == 53 ||
                                            items.item.id_estado == 63 ||
                                            items.item.id_estado == 52 ||
                                            items.item.id_estado == 2 ||
                                            items.item.id_estado == 64)
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue",
                                                    icon: "",
                                                    title: "Memorandum",
                                                    loading: _vm.loading_memos,
                                                    disabled: _vm.loading_memos
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.reporte(
                                                        items.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("description")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !items.item.cargoEspecial &&
                                          items.item.id_tipo_justificacion ==
                                            7 &&
                                          (items.item.id_estado == 1 ||
                                            items.item.id_estado == 53 ||
                                            items.item.id_estado == 63 ||
                                            items.item.id_estado == 52 ||
                                            items.item.id_estado == 2 ||
                                            items.item.id_estado == 64)
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "purple",
                                                    icon: "",
                                                    title: "Resolucion",
                                                    loading: _vm.loading_memos,
                                                    disabled: _vm.loading_memos
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.reporte2(
                                                        items.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("description")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.id_tipo_justificacion ==
                                            14 &&
                                          items.item.id_estado != 32 &&
                                          items.item.id_estado == 18
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue",
                                                    icon: "",
                                                    title:
                                                      "Memorandum suspension"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.reporte5(
                                                        items.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("description")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.bandera == 1 &&
                                          items.item.id_tipo_justificacion ==
                                            5 &&
                                          (items.item.id_estado == 1 ||
                                            items.item.id_estado == 53 ||
                                            items.item.id_estado == 63 ||
                                            items.item.id_estado == 52 ||
                                            items.item.id_estado == 2 ||
                                            items.item.id_estado == 64)
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue",
                                                    icon: "",
                                                    title:
                                                      "Memorandum desvinculacion sin vacación",
                                                    loading: _vm.loading_memos,
                                                    disabled: _vm.loading_memos
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.reporte6(
                                                        items.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("description")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          items.item.bandera == 1 &&
                                          items.item.id_tipo_justificacion ==
                                            5 &&
                                          (items.item.id_estado == 1 ||
                                            items.item.id_estado == 53 ||
                                            items.item.id_estado == 63 ||
                                            items.item.id_estado == 52 ||
                                            items.item.id_estado == 2 ||
                                            items.item.id_estado == 64)
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue",
                                                    icon: "",
                                                    title:
                                                      "Memorandum desvinculacion con vacación",
                                                    loading: _vm.loading_memos,
                                                    disabled: _vm.loading_memos
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.reporte7(
                                                        items.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("description")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1599458231
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0188e6f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0188e6f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/MovilidadFuncionario.vue
// module id = null
// module chunks = 